import { withStyles } from '@material-ui/core/styles';
import Dropdown from './Dropdown';
import styles from './Dropdown.styles';

export default withStyles(styles)(Dropdown);
